module.exports = __webpack_public_path__ + "static/media/dubai.d88e44d8.webp";